import * as React from 'react';
import styled from 'styled-components';

export interface StickyContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Sticky container top offset  */
  top?: React.CSSProperties['top'];
  /** Sticky container left offset */
  left?: React.CSSProperties['left'];
  /** Sticky container right offset */
  right?: React.CSSProperties['right'];
  /** Sticky container bottom offset */
  bottom?: React.CSSProperties['bottom'];
  /** Sticky container margin bottom */
  marginBottom?: React.CSSProperties['marginBottom'];
  /** Sticky container margin top */
  marginTop?: React.CSSProperties['marginTop'];
  /** Sticky container background color */
  background?: React.CSSProperties['backgroundColor'];
  /** Sticky container z-index */
  zIndex?: React.CSSProperties['zIndex'];
}

const StyledContainer = styled.div<StickyContainerProps>`
  position: sticky;
  top: ${props => props.top};
  left: ${props => props.left};
  right: ${props => props.right};
  bottom: ${props => props.bottom};

  margin-bottom: ${props => props.marginBottom};
  margin-top: ${props => props.marginTop};
  background-color: ${props => props.background ?? 'white'};
  z-index: ${props => props.zIndex ?? 999}; // same as src/components/AppShell/AppShell.tsx
`;

/**
 * @group GlobalFilter
 * @purpose Provides a sticky container for the GlobalFilter component
 */
export const StickyContainer = React.forwardRef<HTMLDivElement, StickyContainerProps>((props, ref) => {
  return <StyledContainer ref={ref} {...props} />;
});

StickyContainer.displayName = 'GlobalFilter.StickyContainer';
